import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig   } from '@angular/material/dialog';
import { User                         } from 'src/app/beans/login/user/user.bean';
import { OMOperator                   } from 'src/app/beans/operator/operator.bean';
import { OperatorLevel                } from 'src/app/beans/operator/operator.level.bean';
import { CustomButton, CustomColumn, CustomTableComponent                 } from 'src/app/components/table/custom-table/custom-table.component';
import { GenericDialog } from 'src/app/dialogs/generic/generic.dialog';
import { OperatorDialog               } from 'src/app/dialogs/operator/operator.dialog';
import { DialogsReturnCode            } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager               } from 'src/app/managers/handler/handler.manager';
import { LoadingManager               } from 'src/app/managers/loading/loading.manager';
import { PipeManager                  } from 'src/app/managers/pipe/pipe.manager';
import { SessionManager               } from 'src/app/managers/session/session.manager';

@Component
({
  selector: 'operator.management.page',
  templateUrl: './operator.management.page.html',
  styleUrls: ['./operator.management.page.scss']
})

export class OperatorManagementPage implements OnInit
{
  organizationId: number
  operatorId    : number
  operatorLevel : OperatorLevel[]

  @ViewChild('operatorTable') operatorTable: CustomTableComponent

  operatorColumns: CustomColumn [] = [
    {
      isId    : true,
      label   : "id",
      name    : "id",
      display : ( val : any ) => false ,
    },
    {
      label: "loginName",
      name : "tables.operator.labels.loginName"
    },
    {
      label: "authorization",
      name : "tables.operator.labels.authorization"
    },
    {
      label: "enabled",
      name : "tables.operator.labels.enabled",
      pipe : (enabled: any) => this._pipe.tables().is_enabled(enabled),
    }
  ]

  buttons: CustomButton[] = [
    {
      label : "reset",
      column: "tables.operator.labels.action",
      name  : "tables.operator.resetPassword",
      action: (el: any, pos: number) => {
        this.openDialog("reset", el)
      }
    }
  ]

  values: OMOperator[]

  constructor(
    private _handler  : HandlerManager,
    private _loader   : LoadingManager,
    private _session  : SessionManager,
    private _dialog   : MatDialog     ,
    private _pipe     : PipeManager
  ) { }

  ngOnInit(): void {}

  setOrg(el: any)
  {
    console.log("eccomi nel set");

    this.organizationId = el.id
    this.init()
  }

  //----------------------------------------------------------------------------------------

  async init()
  {
    if(this.organizationId)
    {
      //Get table values
      this.values = await this.retriveValues( this.organizationId );

      this.values.sort( (a,b) => this._pipe.sorting().sort( a.loginName.toLowerCase(), b.loginName.toLowerCase() ) )
      this.values.sort( (a,b) => this._pipe.sorting().sort( a.loginName.length, b.loginName.length ) )
      this.values.sort( (a,b) => this._pipe.sorting().sort( a.authLevel, b.authLevel ) )

      //Get Operator level values
      this.operatorLevel = await this.getOperatorLevel( this.organizationId )
    }
  }

  //----------------------------------------------------------------------------------------

  create()
  {
    this.openDialog( "create", null )
  }

  async update(item: any)
  {
    this.operatorId = item.id
    let operator = await this.getOperatorDetail( this.operatorId )

    this.openDialog( "update", operator )
  }

  //----------------------------------------------------------------------------------------

  openDialog( action:string, operator: OMOperator )
  {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    let dialog: any
    if(action && action != "reset")
    {
      dialogConfig.data = {
        organizationId: this.organizationId,
        operatorLevel : this.operatorLevel ,
        operator      : operator           ,
      }

      dialog = this._dialog.open(OperatorDialog, dialogConfig);
    }
    else if(action && action == "reset")
    {
      dialog = this._dialog.open(GenericDialog, dialogConfig);
    }
    else return

    dialog.afterClosed().subscribe(async (data) =>
    {
      //Refresh table data
      if (data.code == DialogsReturnCode.OPERATOR_ACCEPTED)
      {
        this.values = await this.retriveValues( this.organizationId )
      }
      //Delete message and refresh table data
      if (data.code == DialogsReturnCode.OPERATION_ACCEPTED)
      {
        await this.resetPassword(operator)
        this.values = await this.retriveValues( this.organizationId )
      }
    })
  }

  //----------------------------------------------------------------------------------------

  async retriveValues( organizationId: number )
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    this._loader.start()
    if (this.operatorTable) {
      this.operatorTable.reloadData();
    }
    let response = null

    response = await this._handler.operator().getOperatorList((user as User).token, organizationId)

    this._loader.stop()
    if (this.operatorTable) {
      this.operatorTable.dataLoaded()
    }
    if ( !response      ) return
    if ( !response.list ) return

    return response.list as OMOperator[];
  }

  async getOperatorLevel( organizationId: number )
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    this._loader.start()

    let response = null

    response = await this._handler.operator().getOperatorLevel((user as User).token, organizationId)

    this._loader.stop()

    if ( !response      ) return
    if ( !response.list ) return

    return response.list as OperatorLevel[];
  }

  async getOperatorDetail( operatorId: number )
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    this._loader.start()

    let response = null

    response = await this._handler.operator().getDetail((user as User).token, operatorId)

    this._loader.stop()

    if ( !response        ) return
    if ( !response.object ) return

    return response.object as OMOperator;
  }

  async resetPassword( operator: OMOperator )
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    this._loader.start()

    await this._handler.operator().resetPassword((user as User).token, this.organizationId, operator.id)

    this._loader.stop()
  }
}
